import "./SignUp.css";
import axios from "axios";
import React, { useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import FormCad from "../FormCad/FormCad";
import * as links from "../../../utils/links";
import signin from "../../../assets/images/teste_azul1.png";
import { NotificationContainer } from "react-notifications";

const initialDataSignIn = {
  nome: "",
  cpf: "",
  email: "",
  telefone: "",
  senha: "",
  confirmaSenha: "",
  cep: "",
  endereco: "",
  numero: "",
  bairro: "",
  cidade: "",
  uf: "",
  complemento: "",
};

const initErrorField = {
  nome: undefined,
  cpf: undefined,
  email: undefined,
  telefone: undefined,
  senha: undefined,
  confirmaSenha: undefined,
  cep: undefined,
  endereco: undefined,
  numero: undefined,
  bairro: undefined,
  cidade: undefined,
  uf: undefined,
  complemento: undefined,
};

const somenteNumeros = (valor) => String(valor || "").replace(/\D/g, "");

const mascaraCPF = (valor) => {
  const numeros = somenteNumeros(valor).slice(0, 11);

  return numeros
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
};

const mascaraTelefone = (valor) => {
  const numeros = somenteNumeros(valor).slice(0, 11);

  if (numeros.length <= 2) {
    return numeros.replace(/^(\d{1,2})/, "($1");
  }

  if (numeros.length <= 6) {
    return numeros.replace(/^(\d{2})(\d+)/, "($1) $2");
  }

  if (numeros.length <= 10) {
    return numeros.replace(
      /^(\d{2})(\d{4})(\d{1,4})/,
      "($1) $2-$3"
    );
  }

  return numeros.replace(
    /^(\d{2})(\d{5})(\d{4})/,
    "($1) $2-$3"
  );
};

const mascaraCEP = (valor) => {
  return somenteNumeros(valor)
    .slice(0, 8)
    .replace(/^(\d{5})(\d)/, "$1-$2");
};

const validarCPF = (valor) => {
  const cpf = somenteNumeros(valor);

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  for (let tamanho = 9; tamanho < 11; tamanho++) {
    let soma = 0;

    for (let i = 0; i < tamanho; i++) {
      soma += Number(cpf[i]) * (tamanho + 1 - i);
    }

    const resto = (soma * 10) % 11;
    const digito = resto === 10 ? 0 : resto;

    if (digito !== Number(cpf[tamanho])) {
      return false;
    }
  }

  return true;
};

const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const SignUp = () => {
  const [dataAuth, setDataSingUp] = useState({
    ...initialDataSignIn,
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorField, setErrorField] = useState({
    ...initErrorField,
  });
  const [isLoading, setIsLoading] = useState(false);

  const atualizarCampo = (campo, valor) => {
    setDataSingUp((prev) => ({
      ...prev,
      [campo]: valor,
    }));

    setErrorField((prev) => ({
      ...prev,
      [campo]: undefined,
    }));
  };

  const buscarCEP = async (valor) => {
    const cep = somenteNumeros(valor);

    atualizarCampo("cep", mascaraCEP(valor));

    if (cep.length !== 8) {
      return;
    }

    try {
      const resposta = await axios.get(
        `https://viacep.com.br/ws/${cep}/json/`,
        { timeout: 10000 }
      );

      if (resposta.data.erro) {
        setError("CEP não encontrado.");
        return;
      }

      setError(null);

      setDataSingUp((prev) => ({
        ...prev,
        endereco: resposta.data.logradouro || prev.endereco,
        bairro: resposta.data.bairro || prev.bairro,
        cidade: resposta.data.localidade || prev.cidade,
        uf: resposta.data.uf || prev.uf,
      }));
    } catch (err) {
      setError(
        "Não foi possível consultar o CEP. Preencha o endereço manualmente."
      );
    }
  };

  const onsubmit = async () => {
    if (isLoading) return;

    const erros = {};

    if (!dataAuth.nome.trim()) {
      erros.nome = "Nome obrigatório.";
    }

    if (!validarCPF(dataAuth.cpf)) {
      erros.cpf = "Informe um CPF válido.";
    }

    if (!dataAuth.email.trim()) {
      erros.email = "E-mail obrigatório.";
    } else if (!validateEmail(dataAuth.email.trim())) {
      erros.email = "E-mail inválido.";
    }

    const telefoneNumeros = somenteNumeros(dataAuth.telefone);

    if (telefoneNumeros.length !== 11) {
      erros.telefone = "Informe um WhatsApp válido com DDD.";
    }

    if (somenteNumeros(dataAuth.cep).length !== 8) {
      erros.cep = "Informe um CEP válido.";
    }

    if (!dataAuth.endereco.trim()) {
      erros.endereco = "Endereço obrigatório.";
    }

    if (!String(dataAuth.numero).trim()) {
      erros.numero = "Número obrigatório.";
    }

    if (!dataAuth.bairro.trim()) {
      erros.bairro = "Bairro obrigatório.";
    }

    if (!dataAuth.cidade.trim()) {
      erros.cidade = "Cidade obrigatória.";
    }

    if (!/^[A-Za-z]{2}$/.test(dataAuth.uf.trim())) {
      erros.uf = "Informe a UF com 2 letras.";
    }

    if (!dataAuth.senha) {
      erros.senha = "Senha obrigatória.";
    } else if (dataAuth.senha.length < 6) {
      erros.senha = "A senha deve ter no mínimo 6 caracteres.";
    }

    if (!dataAuth.confirmaSenha) {
      erros.confirmaSenha = "Confirme sua senha.";
    } else if (dataAuth.senha !== dataAuth.confirmaSenha) {
      erros.confirmaSenha = "As senhas não são iguais.";
    }

    setErrorField(erros);
    setSuccess(false);

    if (Object.keys(erros).length > 0) {
      setError("Confira os campos destacados.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const resposta = await axios.post(
        `${process.env.REACT_APP_SERVIDOR}/new-cliente`,
        {
          nome: dataAuth.nome.trim(),
          cpf: somenteNumeros(dataAuth.cpf),
          email: dataAuth.email.trim(),
          telefone: somenteNumeros(dataAuth.telefone),
          senha: dataAuth.senha,
          status: "ANALISE",
          cep: somenteNumeros(dataAuth.cep),
          endereco: dataAuth.endereco.trim(),
          numero: String(dataAuth.numero).trim(),
          bairro: dataAuth.bairro.trim(),
          cidade: dataAuth.cidade.trim(),
          uf: dataAuth.uf.trim().toUpperCase(),
          complemento: dataAuth.complemento.trim(),
        },
        { timeout: 20000 }
      );

      if (resposta.status >= 200 && resposta.status < 300) {
        setSuccess(true);
      } else {
        setError("Não foi possível concluir o cadastro.");
      }
    } catch (err) {
      const mensagemServidor = err.response?.data?.error;

      if (err.response?.status === 400) {
        setError(
          mensagemServidor || "Não foi possível concluir o cadastro."
        );
      } else if (err.code === "ECONNABORTED") {
        setError(
          "O servidor demorou para responder. Verifique se o cadastro foi realizado antes de tentar novamente."
        );
      } else {
        setError(
          mensagemServidor ||
            "Erro ao cadastrar. Tente novamente mais tarde."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const criarCampo = ({
    nome,
    label,
    placeholder,
    width = "100%",
    obrigatorio = false,
    type = "text",
    transformar,
  }) => ({
    obrigatorio,
    width,
    label,
    placeholder,
    name: nome,
    value: dataAuth[nome] ?? "",
    type,
    setField: (valor) => {
      const valorFinal = transformar ? transformar(valor) : valor;
      atualizarCampo(nome, valorFinal);
    },
    error: errorField[nome] ?? "",
  });

  return (
    <>
      <NotificationContainer />

      {isLoading && <LoadingAction />}

      {success ? (
        <FormCad
          authTitle="Seu cadastro foi realizado com sucesso"
          authDescription="Aguarde a análise dos nossos consultores para o retorno de seu cadastro."
          authFields={[]}
          authSubmit="Ir para tela de login"
          textImage="IK Pay systema"
          authImage={signin}
          onsubmit={() => {
            window.location.href = links.SIGNIN;
          }}
          forgot_password={false}
          errorMessage=""
          isSignIn={false}
        />
      ) : (
        <FormCad
          authTitle="Cadastre-se"
          authDescription="Preencha com os seus dados abaixo. Após o envio, seu cadastro entrará em análise."
          new_cad={true}
          authFields={[
            criarCampo({
              nome: "nome",
              label: "Nome completo",
              placeholder: "Digite seu nome completo",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "cpf",
              label: "CPF",
              placeholder: "000.000.000-00",
              obrigatorio: true,
              transformar: mascaraCPF,
            }),

            criarCampo({
              nome: "email",
              label: "E-mail",
              placeholder: "Digite seu e-mail",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "telefone",
              label: "Telefone / WhatsApp",
              placeholder: "(00) 00000-0000",
              obrigatorio: true,
              transformar: mascaraTelefone,
            }),

            {
              ...criarCampo({
                nome: "cep",
                label: "CEP",
                placeholder: "00000-000",
                obrigatorio: true,
              }),
              setField: buscarCEP,
            },

            criarCampo({
              nome: "endereco",
              label: "Endereço",
              placeholder: "Rua, avenida ou logradouro",
              width: "70%",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "numero",
              label: "Número",
              placeholder: "Número",
              width: "calc(30% - 16px)",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "bairro",
              label: "Bairro",
              placeholder: "Digite seu bairro",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "cidade",
              label: "Cidade",
              placeholder: "Digite sua cidade",
              width: "75%",
              obrigatorio: true,
            }),

            criarCampo({
              nome: "uf",
              label: "UF",
              placeholder: "GO",
              width: "calc(25% - 16px)",
              obrigatorio: true,
              transformar: (valor) =>
                valor.replace(/[^a-zA-Z]/g, "").slice(0, 2).toUpperCase(),
            }),

            criarCampo({
              nome: "complemento",
              label: "Complemento",
              placeholder: "Apartamento, bloco, referência (opcional)",
            }),

            criarCampo({
              nome: "senha",
              label: "Senha",
              placeholder: "Mínimo de 6 caracteres",
              width: "calc(50% - 8px)",
              obrigatorio: true,
              type: "password",
            }),

            criarCampo({
              nome: "confirmaSenha",
              label: "Confirmar senha",
              placeholder: "Repita sua senha",
              width: "calc(50% - 8px)",
              obrigatorio: true,
              type: "password",
            }),
          ]}
          authSubmit="Cadastrar"
          textImage="IK Pay systema"
          authImage={signin}
          onsubmit={onsubmit}
          successMessage=""
          errorMessage={error ?? ""}
        />
      )}
    </>
  );
};

export default SignUp;
